import { render } from "./SearchMenu.vue?vue&type=template&id=e1b70fae"
import script from "./SearchMenu.vue?vue&type=script&lang=js"
export * from "./SearchMenu.vue?vue&type=script&lang=js"

import "./SearchMenu.vue?vue&type=style&index=0&id=e1b70fae&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__